import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_pfida/ifa-approval')({
  component: () => <MifeParcel />,
});
